/** What blocks saving a tariff typed in the price editor (components/PriceFields.tsx), by field key: each value is a
 * message key (namespace `rules`) the editor shows with `t()`. */
import type { S } from "../api/client";
import type { MessageKey } from "../i18n/keys";

type Tariff = S["Tariff"];
export type Problems = Record<string, MessageKey>;

const empty = (v: number | null | undefined) => v == null || Number.isNaN(v);

/** What must be fixed before the tariff can be saved, by field key. */
export function priceProblems(t: Tariff): Problems {
  const p: Problems = {};
  const e = t.energy;
  if (e.type === "flat" && empty(e.rate)) p.rate = "rules.prices.problem.rate";
  if (e.type === "tiered") {
    (e.tiers ?? []).forEach((tier, i, all) => {
      if (empty(tier.rate)) p[`tier${i}`] = "rules.prices.problem.tierRate";
      if (i < all.length - 1 && empty(tier.up_to_kwh)) p[`tierEnd${i}`] = "rules.prices.problem.tierEnd";
      if (i > 0 && !empty(tier.up_to_kwh) && (tier.up_to_kwh ?? 0) <= (all[i - 1].up_to_kwh ?? 0)) p[`tierEnd${i}`] = "rules.prices.problem.tierOrder";
    });
  }
  if (e.type === "tou") {
    const seasons = e.seasons ?? [];
    const months = seasons.flatMap((s) => s.months);
    if (new Set(months).size !== 12 || months.length !== 12) p.months = "rules.prices.problem.months";
    seasons.forEach((s, i) => {
      if (empty(s.base_rate)) p[`base${i}`] = "rules.prices.problem.baseRate";
      s.periods.forEach((period, j) => {
        if (empty(period.rate)) p[`period${i}.${j}`] = "rules.prices.problem.periodRate";
        const h = period.hours[0];
        if (h && h.start >= h.end) p[`hours${i}.${j}`] = "rules.prices.problem.hours";
      });
    });
  }
  if (t.export.mode !== "net_metering" && empty(t.export.rate)) p.exportRate = "rules.prices.problem.exportRate";
  return p;
}

